module.exports = __webpack_public_path__ + "static/media/Algebra.0643ffa7.txt";